import React, { FC } from 'react';

export const ErrorPage: FC = () => {
  return <div>oops oh dear!</div>;
};
